<div class="overlay" *ngIf="show()">
  <ng-content></ng-content>
</div>
